export default __webpack_public_path__ + "static/media/news70.861289e1.jpg";